import { render, staticRenderFns } from "./ydXjUpImgOS.vue?vue&type=template&id=32761e84&scoped=true&"
import script from "./ydXjUpImgOS.vue?vue&type=script&lang=js&"
export * from "./ydXjUpImgOS.vue?vue&type=script&lang=js&"
import style0 from "./ydXjUpImgOS.vue?vue&type=style&index=0&id=32761e84&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32761e84",
  null
  
)

export default component.exports